import { render } from "./QuestionPage.vue?vue&type=template&id=414abf60&scoped=true&ts=true"
import script from "./QuestionPage.vue?vue&type=script&lang=ts"
export * from "./QuestionPage.vue?vue&type=script&lang=ts"

import "./QuestionPage.vue?vue&type=style&index=0&id=414abf60&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414abf60"]])

export default __exports__